import { render } from "./ShipmentCheck.vue?vue&type=template&id=319e43c3&ts=true"
import script from "./ShipmentCheck.vue?vue&type=script&lang=ts"
export * from "./ShipmentCheck.vue?vue&type=script&lang=ts"

import "./ShipmentCheck.vue?vue&type=style&index=0&id=319e43c3&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__